import { useState, useEffect } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

//imported
import { EMAIL_PREFERENCES } from "common/viewContent";
import * as actions from "store/actions";
import { getModulesList } from "store/services/emailPreferenceService";
import AddNewModulePopup from "./Components/Modals/AddNewModulePopup";
import EmailPreferenceModule from "./Components/EmailPreferenceModule";
import { Button } from "react-bootstrap";
import AddNewPreferencePopup from "./Components/Modals/AddNewPreferencePopup";

const List = ({
  dispatch,
  modules
}) => {
  // module
  const [showAddModulePopup, setShowAddModulePopup] = useState(false);
  const [editModuleData, setEditModuleData] = useState(null);

  // preference
  const [showAddPrefPopup, setShowAddPrefPopup] = useState(false);
  const [editPrefData, setEditPrefData] = useState(null);

  //get
  async function getData() {
    try {
      dispatch(actions.persist_store({ loader: true }));
      await dispatch(getModulesList());
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }
  useEffect(() => {
    getData();
  }, []);

  const openNewModulePopup = (data) => {
    setShowAddModulePopup(true);
    setEditModuleData(data);
  }

  const closeNewModulePopup = (data) => {
    setShowAddModulePopup(false);
    setEditModuleData(null);
  }

  const openNewPrefPopup = (data) => {
    setShowAddPrefPopup(true);
    setEditPrefData(data);
  }
  
  const closeNewPrefPopup = (data) => {
    setShowAddPrefPopup(false);
    setEditPrefData(null);
  }

  return (
    <>
      <Helmet title={EMAIL_PREFERENCES.CURRENT_MODULE} />
      <AddNewModulePopup
        showPopup={showAddModulePopup}
        closePopup={closeNewModulePopup}
        data={editModuleData}
      />
      <AddNewPreferencePopup
        showPopup={showAddPrefPopup}
        closePopup={closeNewPrefPopup}
        data={editPrefData}
      />
      <section className="section">
        <div className="section-header">
          <h1>{EMAIL_PREFERENCES.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item">View Audit Logs</div>
          </div>
        </div>
        <div className="section-body">
          <div className="position-relative">
            <h2 className="section-title">{EMAIL_PREFERENCES.CURRENT_MODULE}</h2>
            <p className="section-lead">
              In this section, you can manage email notification preferences for various system modules.
            </p>
            <Button
              type="button"
              variant="primary"
              className="position-absolute top-0 end-0"
              onClick={openNewModulePopup}
            >
              Add New Module
            </Button>
          </div>

          <div className="row">
            <div className="col-12">
            <EmailPreferenceModule
              handleEdit={openNewModulePopup}
              data={modules}
              handleEditPreference={openNewPrefPopup}
            />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    modules: state.EmailPreferences.modules,
    isLoading: state.persistStore.loader,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
